import React from 'react'
import Header from '../components/header'
import BreadCrumb from '../components/BreadCrumb'
import DownloadArea from '../components/DownloadArea'
import GoogleMap from '../components/GoogleMap'
import Footer from '../components/footer'
import ContactArea from '../components/ContactArea'

function ContactPage() {
  const pageName = "Contact Us"
  return (
    <div className='home-3'>
      <Header/>
      <BreadCrumb pageName={pageName}/>
      <main>
        <ContactArea/>
        <DownloadArea/>
        <GoogleMap/>
      </main>
      <Footer/>
    </div>
  )
}

export default ContactPage